// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hunters-menu-container[data-v-c18036a2]{border-bottom:1px solid #fff;width:100%;padding:10px;font-family:Fanwood Text;font-size:14px;font-weight:400;line-height:18px;letter-spacing:.065em;text-align:center;color:#ed1c24;text-transform:uppercase}.hunters-menu-cell[data-v-c18036a2]{border-right:1px solid #fff}.hunters-menu-link[data-v-c18036a2]{color:#ed1c24;text-decoration:none}", ""]);
// Exports
module.exports = exports;
